import * as React from 'react';
import logo from '../../images/brand/logo.svg';
var Logo = function (props) {
    return (React.createElement("img", { className: "navbar-brand-full", src: logo, width: props.width, height: props.height, alt: props.alt }));
};
export default Logo;



//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo.tsx
// module id = 232
// module chunks = 0